module.exports = __webpack_public_path__ + "static/media/tagalongRounded.871ae086.png";